import React, { Component, Fragment } from "react";

interface WithOpenProps {
    render: (isOpen: boolean, toggleOpen: () => void, close?: () => void, open?: () => void) => any;
}

interface WithOpenState {
    isOpen: boolean;
}

class WithOpen extends Component<WithOpenProps, WithOpenState> {
    constructor(props: WithOpenProps) {
        super(props);
        this.state = {
            isOpen: false,
        };
    }

    public render() {
        return <Fragment>{this.props.render(this.state.isOpen, this.toggleOpen, this.close, this.open)}</Fragment>;
    }

    private close = () => {
        this.setState(() => {
            return {
                isOpen: false,
            };
        });
    };

    private open = () => {
        this.setState(() => {
            return {
                isOpen: true,
            };
        });
    };

    private toggleOpen = () => {
        this.setState(({ isOpen }) => {
            return {
                isOpen: !isOpen,
            };
        });
    };
}

export default WithOpen;
